import styled, { css } from 'styled-components'
import { up } from 'styled-breakpoints'
import { FormProvider, useForm } from 'react-hook-form'
import Router from 'next/router'
import { useDispatch } from 'react-redux'
import Button from '../../../components/Button'
import FieldText from '../../../components/Fields/FieldText'
import validationErrors from '../../../services/helpers/errors'
import usePromise from '../../../hooks/usePromise'
import auth from '../authSlice'

function Register() {
  const formMethods = useForm()
  const dispatch = useDispatch()

  const [registration, onSubmit] = usePromise(async (data) => {
    await dispatch(auth.register(data))
    Router.replace('/auth/register-success')
  })

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <FormProvider {...formMethods}>
      <StyledRegisterForm
        autoComplete="off"
        onSubmit={formMethods.handleSubmit(onSubmit)}
      >
        <StyledRegisterFormText>
          Заполните данные ниже, чтобы зарегистрироваться в нашей системе. После
          успешного заполнения данных менеджер вышлет вам индивидуальный логин и
          пароль.
        </StyledRegisterFormText>

        <StyledRegisterGrid>
          <StyledRegisterRow>
            <StyledRegisterCell fixed>
              <FieldText
                type="tel"
                placeholder="УНП"
                name="inn"
                serverErrors={registration.exception?.errors?.inn}
                validateRules={{
                  required: validationErrors().reg_inn_required,
                }}
              />
            </StyledRegisterCell>
            <StyledRegisterCell stretch>
              <FieldText
                placeholder="Наименование юр. лица"
                name="full_name"
                serverErrors={registration.exception?.errors?.full_name}
                validateRules={{
                  required: validationErrors().reg_full_name_required,
                }}
              />
            </StyledRegisterCell>
          </StyledRegisterRow>

          <StyledRegisterRow>
            <StyledRegisterCell full>
              <FieldText
                placeholder="Контактное лицо"
                name="contact_fio"
                serverErrors={registration.exception?.errors?.contact_fio}
                validateRules={{
                  required: validationErrors().reg_contact_fio_required,
                }}
              />
            </StyledRegisterCell>
          </StyledRegisterRow>

          <StyledRegisterRow>
            <StyledRegisterCell>
              <FieldText
                placeholder="Email"
                type="email"
                name="email"
                serverErrors={registration.exception?.errors?.email}
                validateRules={{
                  required: validationErrors().email_required,
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: validationErrors().email_valid,
                  },
                }}
              />
            </StyledRegisterCell>
            <StyledRegisterCell>
              <FieldText
                placeholder="Телефон"
                type="tel"
                name="phones"
                serverErrors={registration.exception?.errors?.phones}
                validateRules={{
                  required: validationErrors().reg_phones_required,
                }}
              />
            </StyledRegisterCell>
          </StyledRegisterRow>
        </StyledRegisterGrid>

        <StyledRegisterFormControls>
          <StyledRegisterFormCell>
            <Button loading={registration.isPending}>Зарегистрироваться</Button>
          </StyledRegisterFormCell>
        </StyledRegisterFormControls>
      </StyledRegisterForm>
    </FormProvider>
  )
}

const StyledRegisterGrid = styled.div`
  margin-bottom: -20px;

  ${up('md')} {
    margin-bottom: -24px;
  }
`

const StyledRegisterRow = styled.div`
  ${up('md')} {
    display: flex;
    flex-wrap: nowrap;
    margin-left: -12px;
    margin-right: -12px;
  }
`

const StyledRegisterFixed = css`
  flex: 0 0 auto;
  width: 220px;
  max-width: 220px;
`
const StyledRegisterStretch = css`
  flex: 1 1 auto;
  width: 100%;
  max-width: 100%;
`

const StyledRegisterCell = styled.div`
  padding-bottom: 20px;

  ${up('md')} {
    padding-left: 12px;
    padding-right: 12px;
    padding-bottom: 24px;
    width: ${(props) => (props.full ? '100%' : '50%')};
    max-width: ${(props) => (props.full ? '100%' : '50%')};

    ${(props) => props.fixed && StyledRegisterFixed}
    ${(props) => props.stretch && StyledRegisterStretch}
  }
`

const StyledRegisterForm = styled.form`
  display: block;
  width: 670px;
  max-width: 100%;
`
const StyledRegisterFormText = styled.p`
  font-size: 18px;
  line-height: 140%;
  color: ${(props) => props.theme.textColor};

  margin-bottom: 25px;
  margin-top: 25px;

  ${up('md')} {
    margin-bottom: 35px;
    margin-top: 35px;
  }
`

const StyledRegisterFormControls = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  min-width: 0;
  margin-left: -5px;
  margin-right: -5px;
  justify-content: space-between;
  margin-top: 30px;

  ${up('md')} {
    margin-top: 35px;
  }
`
const StyledRegisterFormCell = styled.div`
  flex: 0 0 auto;
  padding-left: 5px;
  padding-right: 5px;
`

Register.defaultProps = {}

Register.propTypes = {}

export default Register
